var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isLoading)?_c('div',{attrs:{"id":"loader-wrapper"}},[_c('div',{attrs:{"id":"loader"}}),_c('div',{staticClass:"load_title"},[_vm._v("正在拼命加载中,请耐心等待....")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }